import { gql } from '@apollo/client';

export const exerciseMediaItemFragment = gql`
  fragment ExerciseMediaItem on ExerciseMediaItem {
    id: _id
    type
    name
    thumbUrl
    url
    processed
    sources {
      size
      src
      type
    }
  }
`;

export const exerciseFragment = gql`
  fragment Exercise on Exercise {
    id: _id
    type
    code
    createdAt
    text
    forPractice
    timeLimit
    media @type(name: "ExerciseMediaItem") {
      ...ExerciseMediaItem
    }
    explanation {
      text
      media @type(name: "ExerciseMediaItem") {
        ...ExerciseMediaItem
      }
    }
  }
  ${exerciseMediaItemFragment}
`;
